import { createContext } from "react";
import { IClientContext } from "./client-context.types";

export const defaultContext: IClientContext = {
    clientId: "",
    client: "",
    isAgentReviewEnabled: false,
    isExploreTagsEnabled: false,
    isLiveViewEnabled: false,
    isAgentTaggingEnabled: false,
    isCallListeningEnabled: false,
    isExternalTaggingEnabled: false,
    isTranslationEnabled: false,
    isInteractionSummaryEnabled: false,
    isInteractionGroupSummariesEnabled: false,
    segmentTagGroupId: "",
    agentAccessRoleId: "",
    contactReasonTagGroupId: null,
    isManageTeamsEnabled: false,
};

export const ClientContext = createContext<IClientContext>(defaultContext);
